import { render, staticRenderFns } from "./AuthCoverLayout.vue?vue&type=template&id=35ce9424"
import script from "./AuthCoverLayout.vue?vue&type=script&lang=js"
export * from "./AuthCoverLayout.vue?vue&type=script&lang=js"
import style0 from "./AuthCoverLayout.vue?vue&type=style&index=0&id=35ce9424&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VApp } from 'vuetify/lib/components/VApp';
import { VCard } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VMain } from 'vuetify/lib/components/VMain';
installComponents(component, {VApp,VCard,VContainer,VMain})
